import styled from 'styled-components';
import { P12 } from './P12';

export const P12M = styled(P12)`
  font-weight: 500;
  margin: ${({ margin }) => `${margin}`};
`;
